import React, { useState, useContext } from "react";
import { Popover } from "antd";
import axios from "axios";
import { CatTagContext } from "../../contexts/CatTagContext";

const AddCategory = () => {
  const { categories, fetchCategories } = useContext(CatTagContext);
  const [visible, setVisible] = useState(false);
  const [cName, setCName] = useState("");
  const hide = () => {
    setVisible(false);
  };
  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };
  const content = (
    <div className='flex items-center'>
      <input
        autoFocus
        className='w-full py-1 px-2 focus:outline-none focus:shadow-outline rounded-sm border-2 border-gray-300'
        value={cName}
        onChange={(e) => setCName(e.target.value)}
      />
      <div
        onClick={addNewCat}
        style={{ height: "2.4rem" }}
        className='flex justify-center items-center py-1 px-3 m-0 ml-3 bg-blue-400 text-white rounded-md cursor-pointer'
      >
        <p className='m-0 p-0'>ADD</p>
      </div>
    </div>
  );
  function addNewCat() {
    let checker = false;
    categories.forEach((e) => {
      if (
        e.category.replace(/"/g, "'").replace(/'/g, "\\'") ===
        cName.replace(/"/g, "'").replace(/'/g, "\\'")
      ) {
        checker = true;
      }
    });
    if (checker === false && cName.length > 0) {
      const theCatName = cName.replace(/"/g, "'").replace(/'/g, "\\'");
      axios
        .post("/categories", { theCatName })
        .then(() => {
          fetchCategories();
          setCName("");
          hide();
        })
        .catch((e) => console.log(e));
    }
  }
  return (
    <Popover
      visible={visible}
      onVisibleChange={handleVisibleChange}
      content={content}
      trigger='click'
      placement='bottom'
    >
      <div
        className={`cursor-pointer flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 hover:bg-gray-100 ${
          visible ? "bg-gray-100" : "bg-white"
        }`}
      >
        <span className='flex items-center justify-center text-lg text-green-400'>
          <svg
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            viewBox='0 0 24 24'
            stroke='currentColor'
            className='h-6 w-6'
          >
            <path d='M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z'></path>
          </svg>
        </span>
        <span className='ml-3'>Add New</span>
      </div>
    </Popover>
  );
};

export default AddCategory;
